import ProductCard from '~/components/ProductCard.tsx'
import type { Product } from '@prisma/client'

type ProductCardGridProps = {
	products: Product[]
	count?: number
	sliceFromEnd?: boolean
}

export default function ProductCardGrid({
	products,
	count = Infinity,
	sliceFromEnd = false,
}: ProductCardGridProps) {
	const slicedProducts = sliceFromEnd
		? products.slice(-count)
		: products.slice(0, count)

	return (
		<div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:gap-x-8">
			{slicedProducts.map((product: Product) => (
				<ProductCard product={product} key={product.name} />
			))}
		</div>
	)
}
